import {get} from "lodash-es";
import {isLoggedIn} from "modules/selectors";
import React from "react";
import {useSelector} from "react-redux";
import {Outlet, useLocation} from "react-router";
import {Navigate, type RouteProps} from "react-router-dom";

export const NotAuthOnlyRoute: React.FC<RouteProps> = (_props) => {
	const location = useLocation();
	const backURL = get(location, "state.from.pathname", "/") as string;

	if (useSelector(isLoggedIn)) {
		return <Navigate to={backURL} replace={true} />;
	}

	return <Outlet />;
};
